import { Space } from "antd";
import { useEffect, useRef, useState } from "react";
import { ReactComponent as IconClock } from "../../assets/images/Clock.svg";
import { ReactComponent as IconClose } from "../../assets/images/Close.svg";
import API_SERVICE from "shared/services/api-service";

const FollowUpReminderNotification = () => {
  const [followUpReminderData, setFollowUpReminderData] = useState([]) as any;
  const [showCaseId, setShowCaseId] = useState<string[]>([]);
  const lastResponseCaseIdsRef = useRef<string[]>([]);

  useEffect(() => {
    getFollowUpRemindersData();
    const interval = setInterval(() => {
      getFollowUpRemindersData();
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const getFollowUpRemindersData = () => {
    const payload = {
      caseIds: lastResponseCaseIdsRef.current,
      loggedInFrom: "WEB",
    };
    API_SERVICE.getFollowUpReminders(payload).then(({ data }) => {
      if (data && data.payload) {
        const receivedItems = data.payload;
        setFollowUpReminderData((prevData) => [...prevData, ...receivedItems]);
        const receivedCaseIds = receivedItems.map((item) => item.caseId);
        lastResponseCaseIdsRef.current = Array.from(
          new Set([...lastResponseCaseIdsRef.current, ...receivedCaseIds])
        );
      }
    });
  };

  return (
    <div className="followup-notification-wrapper">
      <div className="followup-notification-container">
        {followUpReminderData
          .filter((item) => !showCaseId.includes(item.caseId))
          .map((item) => (
            <div className="followup-notification" key={item.caseId}>
              <Space>
                <IconClock className="clock" />
                <p className="clock-para">{item.reminderMessage}</p>
                <IconClose
                  className="close"
                  onClick={() => {
                    setShowCaseId((prev: any[]) => [...prev, item.caseId]);
                  }}
                />
              </Space>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FollowUpReminderNotification;
